// This is the front-end for the Interactive Lawyer Search.
// The process is triggered when a user types into the complaint form
// at /for-the-public/file-complaint. When the text of the search field is
// greater than 3 characters, make an AJAX call to the search controller
// to load results back from the AttorneyLookupsForComplaints database model.

function lookup_bpr_number_to_update_attorney_display(bpr_number, results_area_div) {
  if (bpr_number.length == 6) {
    results_area_div.innerText = '...';
    $.get(
      "/autocomplete/attorney_lookup_for_complaints/?id=" + bpr_number,
      function(data) {
        results_area_div.innerHTML = data;
      }
    );
  } else {
    results_area_div.innerText = '...';
  }
};

const addLawyerSearch = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const complaintForm = document.querySelector('form#new_complaint');
    const lawyerSearchInput = complaintForm.querySelector(
      '#complaint_lawyer_query',
    );
    const resultArea = complaintForm.querySelector('.results-area');
    const formSubmitButton = complaintForm.querySelector('button[type="submit"]');
    const clearSearchButton = complaintForm.querySelector('#clear-search-button');
    let _changeInterval = null;

    const queryLawyers = e => {
      clearInterval(_changeInterval);
      _changeInterval = setInterval(function() {
        clearInterval(_changeInterval);
      }, 2000);

      const search_value = $('#complaint_lawyer_query').val();
      if (search_value.length <= 2) {
        return;
      }

      return $.post(
        '/autocomplete/attorney_lookup_for_complaints',
        {query: search_value},
        function(data) {
          $('#results').html(data);
          $('#results').on('click', '.attorney-result', function() {
            return selectAttorney($(this));
          });
          return $('.results-area').show();
        },
      );
    };

    const selectAttorney = function(attorney_result) {
      if (attorney_result.data('deceased') == true) {
        showDeceasedSections(true)
        return
      } else {
        showDeceasedSections(false)
      }
      
      if (
        typeof attorney_result.attr('id') === undefined ||
        typeof attorney_result === undefined
      ) {
        return;
      }

      const lawyerInformation = getNodeList(attorney_result)
        .map(element => stripNewlines(element.innerText))
        .join(' ');

      lawyerSearchInput.value = lawyerInformation;
      updateBprForm(attorney_result.attr('id'));
      resultArea.style.display = 'none';
    };

    const showDeceasedSections = (deceased) => {
      if (deceased) {
        $('.show-if-deceased').show()
        $('.hide-if-deceased').hide()
      } else {
        $('.show-if-deceased').hide()
        $('.hide-if-deceased').show()
      }
    };

    const updateBprForm = bprNumber => {
      var bpr_number_text_field = document.getElementById('complaint_lawyer_bpr_number');
      bpr_number_text_field.value = bprNumber;

      var bpr_number_attorney_div = document.getElementById('complaint_lawyer_bpr_number_results');
      bpr_number_attorney_div.innerText = 'Updating...';
      lookup_bpr_number_to_update_attorney_display(bprNumber, bpr_number_attorney_div);
    };

    const getNodeList = element => {
      if (element.childNodes === undefined) {
        return [...element[0].childNodes];
      } else {
        return [...element.childNodes];
      }
    };

    const stripNewlines = string => {
      return string.replace(/(\r\n|\n|\r)/gm, '');
    };

    clearSearchButton.addEventListener('click', e => {
      e.preventDefault();
      lawyerSearchInput.value = '';
      resultArea.style.display = 'none';
    });

    lawyerSearchInput.addEventListener('keyup', queryLawyers);
  });
}



$(document).ready(function() {

  // Add automatic lookup for typed BPR number
  $('.bpr_number_with_result').keyup(function() {
    var bprNumber = $(this).val();
    var resultsAreaDivId = $(this).attr('id') + "_results"; // Construct the results area ID based on the input ID
    var resultsAreaDiv = document.getElementById(resultsAreaDivId);

    lookup_bpr_number_to_update_attorney_display(bprNumber, resultsAreaDiv);
  });
});

if ($('form#new_complaint').length) {  
  lawyer_search = document.getElementById('complaint_lawyer_query');
  if(lawyer_search) {
    addLawyerSearch();
  }  
}


